import { render } from "./GameRounds.vue?vue&type=template&id=80363a74"
import script from "./GameRounds.vue?vue&type=script&lang=ts"
export * from "./GameRounds.vue?vue&type=script&lang=ts"
script.render = render

export default script